import { CroppedImage } from '../..'

export class PageBase {
    name: string
    url: string
    urlSegment: string
    nodeId: number
    alias: string

    // SEO stuff
    seoImage: CroppedImage
    metaKeywords: string
    metaDescription: string
    seoPageTitle: string
    oGType: string
    oGLocale: string
    twitterCard: string
    seoUrl: string
}
